export const API_URL = process.env.API_URL;
export const IMAGE_URL = process.env.IMAGE_URL;
export const SERVER = process.env.SERVER === 'true';
export const CLIENT = !SERVER;
export const REDUX_DEV_TOOLS = process.env.REDUX_DEV_TOOLS === 'true';
export const RAFFLE_IMAGE_URL = `${IMAGE_URL}/images/raffle`;
export const FOOTSHOP_BASE_URL = process.env.FOOTSHOP_BASE_URL.replace(/\/$/, ''); // Remove trailing slash
export const HOMEPAGE_ACTIVE_PAGE_SIZE = process.env.HOMEPAGE_ACTIVE_PAGE_SIZE;
export const HOMEPAGE_CLOSED_PAGE_SIZE = process.env.HOMEPAGE_CLOSED_PAGE_SIZE;
export const HOMEPAGE_RELOAD_THRESHOLD_SECONDS = 60;
export const GOOGLE_MAPS_API_CALLBACK_NAME = 'googleMapsApiLoaded';
export const GOOGLE_MAPS_API_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_API_KEY}&libraries=places&callback=${GOOGLE_MAPS_API_CALLBACK_NAME}&fields=address_component,adr_address,formatted_address,geometry,icon,id,name,place_id,scope,url,utc_offset,vicinity`;
export const HCAPTCHA_SITE_KEY = process.env.HCAPTCHA_SITE_KEY;

export const EXTERNAL_URL_MAP = {
	'/payment-and-delivery': 'https://www.footshop.com/en/content/5-payment-and-delivery',
	'/returns-and-exchanges': 'https://www.footshop.com/en/content/16-returns-and-exchanges',
	'/phone': 'tel:+44 2038071459',
	'/faq': 'https://intercom.help/footshopcs/releases',
	'/about': 'https://about.footshop.com/en/',
	'/facebook': 'https://www.facebook.com/footshop',
	'/twitter': 'https://twitter.com/footshopeu',
	'/youtube': 'https://www.youtube.com/c/FootshopEurope',
	'/footshop': 'https://www.footshop.com/',
	'/instagram': 'https://www.instagram.com/footshop/?hl=cs',
	'/latest': 'https://www.footshop.com/en/1551-latest',
	'/men': 'https://www.footshop.com/en/5-mens-shoes',
	'/women': 'https://www.footshop.com/en/6-womens-shoes',
	'/kids': 'https://www.footshop.com/en/55-kids-shoes',
	'/accessories': 'https://www.footshop.com/en/61-accessories',
	'/sales': 'https://www.footshop.com/en/872-sale',
	'/brands': 'https://www.footshop.com/en/brands',
	'/info': 'https://www.footshop.com/en/content/3-info'
};


export const ESHOP_HOMEPAGE_MAP = {
	1: 'https://www.footshop.cz/cs/',
	2: 'https://www.ftshp.de/de/',
	3: 'https://www.footshop.sk/sk/',
	4: 'https://www.footshop.pl/pl/',
	5: 'https://www.footshop.es/es/',
	6: 'https://www.footshop.eu/en/',
	7: 'https://www.footshop.fr/fr/',
	8: 'https://www.footshop.it/it/',
	9: 'https://www.ftshp.co.uk/en-uk/',
	10: 'https://www.footshop.hu/hu/',
	12: 'https://www.footshop.com/en/',
	13: 'https://www.footshop.ro/ro/',
	14: 'https://www.footshop.bg/bg/',
	17: 'https://www.footshop.eu/at/',
	18: 'https://www.footshop.hr/hr/',
	20: 'https://www.footshop.si/sl/',
	22: 'https://www.ftshp.nl/nl/',
	25: 'https://www.footshop.gr/el/',
	31: 'https://www.ftshp.be/nl/',
	34: 'https://www.ftshp.be/fr/',
	35: 'https://www.ftshp.se/sv/',
	36: 'https://www.ftshp.fi/fi/',
	37: 'https://www.footshop.dk/da/',
	38: 'https://www.footshop.no/no/',
	39: 'https://www.footshop.ch/de/',
	40: 'https://www.footshop.ie/en/',
	41: 'https://www.footshop.ee/et/',
	42: 'http://footshop.lv/lv/',
	43: 'http://footshop.lt/lt/',
	44: 'http://footshop.pt/pt/'
};



// WEBPACK FOOTER //
// ./parameters.js